// 其他監控來源：接第三方監控平台 API（Thingnario / SolarEdge / SmartPVMS ...）
// 兩頁：即時總覽（來源之間用頁內 tab 切換）、資料下載（來源用下拉選）
//
// 這裡新增一頁，群組管理的「其他監控來源 可觀看項目」會自動多一個勾選框
// （GroupManage.vue 的 otherSourcesSideMenuOptions 就是讀這個陣列）。
// 新頁面預設沒有人有權限，要到群組管理勾起來才看得到。
export const projectOtherSourcesRoutes = [
  {
    path: 'othersources',
    name: 'othersources',
    component: () => import('@/views/OtherSources.vue'),
    meta: {
      release: true,
      zhTw: '其他監控來源',
      icon: 'fas fa-plug',
      showMenu: true
    }
  },
  {
    path: 'othersourcesdownload',
    name: 'othersourcesdownload',
    component: () => import('@/views/OtherSourcesDownload.vue'),
    meta: {
      release: true,
      zhTw: '監控來源資料下載',
      icon: 'fas fa-solid fa-download',
      showMenu: true
    }
  }
]
